import { Component, EventEmitter, Injector, Input, OnInit, Output, inject } from '@angular/core';
import { Provider } from 'app/core/models/provider.model';
import { ProviderService } from 'app/core/services/provider.service';
import { ProviderOffice } from 'app/core/models/provider-office.model';
import { ProviderSpecialistDetectionLlmResult } from 'app/core/models/provider-specialist-detection-llm-result.model';
import { NotesForModelComponent } from '../../../shared/components/notes-for-model/notes-for-model.component';
import { DatePipe } from '@angular/common';
import { BlankValueDashPipe } from 'app/shared/pipes/blank-value-dash.pipe';
import { ProviderOfficeNewFormComponent } from '../provider-office-new-form/provider-office-new-form.component';
import { ProviderOfficeListComponent } from '../provider-office-list/provider-office-list.component';
import { ProviderInformationCollectionDetailsComponent } from '../provider-information-collection-details/provider-information-collection-details.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {
  SpecialistDetectionClaimsModalComponent,
  SpecialistDetectionClaimsModalData,
} from '../specialist-detection-claims-modal/specialist-detection-claims-modal.component';

@Component({
  selector: 'app-provider-detail',
  templateUrl: './provider-detail.component.html',
  styleUrls: ['./provider-detail.component.scss'],
  imports: [NotesForModelComponent,
    ProviderOfficeNewFormComponent,
    ProviderOfficeListComponent,
    ProviderInformationCollectionDetailsComponent,
    DatePipe,
    BlankValueDashPipe,
  ]
})
export class ProviderDetailComponent implements OnInit {
  private providerService = inject(ProviderService);
  private modalService = inject(NgbModal);
  private injector = inject(Injector);

  @Input() provider: Provider;
  @Output() providerChange = new EventEmitter();

  providerOffices: ProviderOffice[];
  providerOfficesLoading = true;

  showAddOffices = false;


  ngOnInit() {
    this.loadProviderOffices();
  }

  onViewClaimsClick($event: MouseEvent, result: ProviderSpecialistDetectionLlmResult) {
    $event.preventDefault();
    const modalOptions = new SpecialistDetectionClaimsModalData();
    modalOptions.claims = result.rawInput[1];

    this.modalService.open(SpecialistDetectionClaimsModalComponent, {
      injector: Injector.create({
        providers: [{ provide: SpecialistDetectionClaimsModalData, useValue: modalOptions }],
        parent: this.injector,
      }),
    });
  }

  get showSpecialistDetectionLlmResults() {
    return this.provider.llmSpecialistDetectionResults?.length > 0;
  }

  get hasNonCuratedOverride() {
    return this.provider.llmSpecialistDetectionResults?.some(r => r.choiceResponse?.nonCuratedOverride);
  }

  onAddNewOfficesClick() {
    this.showAddOffices = true;
  }

  onOfficeAdded() {
    this.loadProviderOffices();
    this.providerChange.emit();
  }

  onOfficeFormCompleted() {
    this.showAddOffices = false;
  }

  private loadProviderOffices() {
    this.providerService.getProviderOffices(this.provider.id).subscribe((providerOffices: ProviderOffice[]) => {
      this.providerOffices = providerOffices;
      this.providerOfficesLoading = false;
    });
  }
}
